<template lang="pug">
    transition(name="fade" mode="out-in")
        #SchoolInfo(v-if="school" :key="schoolp.ENTITY_CODE")

            template(v-if="isZonedSchool && zonedSchoolCount > 1")
                h4(v-if="zonedSchoolPos === 0") For {{ stage }} enrolments, your address is in the zone for {{ zonedSchoolCount }} schools.
            h4(v-else-if="isZonedSchool") For {{ stage }} enrolments, your address is in the {{ boundarySetTitle.toLowerCase() }} school zone for:
            .container
                h2#SchoolInfo-header {{ schoolp.School_Name }}
                table
                    tr.campus(v-if="schoolp.Campus_Name !== schoolp.School_Name")
                        th Campus
                        td {{ schoolp.Campus_Name }}
                            |  {{ schoolp.School_Type}}
                            span(v-if="!schoolp.Specialisation && schoolp.School_Type !== schoolp.Campus_Type")   ({{ schoolp.Campus_Type }})

                    tr(v-if="schoolp.Campus_Year_Levels")
                        th Campus years
                        td
                            | {{ schoolp.Campus_Year_Levels }}
                            div
                                a(href="#" v-show="schoolp.Campus_Desc && !showCampusDesc" @click="showCampusDesc=true") More info
                    tr(v-if="schoolp.Campus_Desc && showCampusDesc")
                        td.campus_desc(colspan="2")
                            div {{ schoolp.Campus_Desc }}
                    tr(v-if="schoolp.Specialisation")
                        th Specialisation
                        td
                            | {{ schoolp.Specialisation }}
                            div
                                a(href="#" v-show="!showDesc" @click="showDesc=true") More info

                    tr(v-if="schoolp.Specialisation_Desc && showDesc")
                        td.specialisation_desc(colspan="2")
                            div {{ schoolp.Specialisation_Desc }}
                    tr(v-if="schoolp.Campus_Address_Line")
                        th Address
                        td
                            .address {{ schoolp.Campus_Address_Line }}
                            .address {{ schoolp.Campus_Address_Town }} {{ schoolp.Campus_Postcode }}
                    tr(v-if="schoolp.School_Phone")
                        th School phone
                        td {{ schoolp.School_Phone }}
                    tr(v-if="schoolp.School_Website")
                        th Website
                        td
                            a.only-screen(:href="schoolp.School_Website" target="_blank" :aria-label="schoolInfo" ref="schoolInfoLink") Visit school site
                            span.only-print {{ schoolp.School_Website }}
                    tr(v-if="schoolp.Managed_Enrolments")
                        th Managed enrolments
                        td {{ schoolp.Managed_Enrolments }}
                    tr(v-if="schoolp.Region")
                        th Region
                        td {{ schoolp.Region }}
                    tr(v-if="hasContactValue(schoolp.Region_Phone)")
                        th Department contact
                        td {{ schoolp.Region_Phone }}
                            div(v-if="hasContactValue(schoolp.Region_Email)")
                                a(:href="'mailto:' + schoolp.Region_Email") Email
                    tr(v-if="zonedSchoolPos > 0")
                        td.show-zone-link(colspan="2")
                            a(href="#" @click="clickSeeMore") Show School Zone

                .maplink.only-mobile(@click="viewOnMap") View on map

</template>

<script>
import { EventBus } from './EventBus';
export default {
    name: 'SchoolInfo',
    components: {},
    props: [
        'school',
        'isZonedSchool', // is this the result of a zone query, or just direct selection
        'zonedSchoolCount', // how many zoned schools in list (for pluralisation)
        'zonedSchoolPos', // position within list (first one gets a preamble)
    ],
    data: () => ({
        showDesc: false, // whether to show specialisation description
        showCampusDesc: false, // whether to show extra campus description (eg for non-operational schools)
    }),
    computed: {
        schoolp() {
            return this.school.properties;
        },
        schoolInfo() {
            if (!this.school) {
                return undefined;
            }
            const p = this.schoolp;
            let schoolInfo = `${p.School_Name}. Press enter to visit the school website. `;

            if (p.Campus_Name !== p.School_Name) {
                schoolInfo += `Campus: ${p.Campus_Name} (${p.Campus_Type}). `;
            }
            if (p.Campus_Year_Levels) {
                schoolInfo += `Campus years: ${p.Campus_Year_Levels}. `;
            }
            if (p.Campus_Address_Line) {
                schoolInfo += `Address: ${p.Campus_Address_Line} ${p.Campus_Address_Town} ${p.Campus_Postcode}. `;
            }
            if (p.School_Phone) {
                schoolInfo += `Phone: ${p.School_Phone} . `;
            }
            if (p.Managed_Enrolments) {
                schoolInfo += `Managed enrollments: ${p.Managed_Enrolments} . `;
            }
            if (p.Region) {
                schoolInfo += `Region: ${p.Region} . `;
            }
            return schoolInfo;
        },
        boundarySetTitle() {
            return window.app.BoundarySelector.getBoundarySetTitle(
                this.school.properties.queryYear
            );
        },
        stage() {
            return window.app.BoundarySelector.stage;
        },
        isRegularZoned() {
            return !!this.school.properties[
                window.app.BoundarySelector.boundarySet
            ];
        },
    },
    watch: {
        school() {
            this.showDesc = false;
            this.showCampusDesc = false;
        },
    },
    created() {
        window.app.SchoolInfo = this;
    },
    methods: {
        hasContactValue(value) {
            if (value === null || value === undefined) {
                return false;
            }
            if (typeof value === 'string') {
                const normalized = value.trim().toLowerCase();
                return (
                    normalized !== '' &&
                    normalized !== 'null' &&
                    normalized !== 'undefined'
                );
            }
            return true;
        },
        viewOnMap() {
            window.app.App.sidebarOpen = false;
            window.app.Map.zoomToSchool(this.school, true);
            window.track('App', 'view-on-map');
        },
        clickSeeMore(e) {
            e.preventDefault();
            EventBus.$emit('school-select', this.school, true);
            this.$nextTick(() =>
                document.getElementById('SchoolInfo').scrollIntoView()
            );
        },
    },
};
</script>

<style scoped>
#SchoolInfo {
    margin-top: 1em;
}

.container {
    background: #e8effc;
    padding: 1em;
    border-radius: 3px;
    box-shadow: 0 0 0 2px rgba(0, 0, 0, 0.1);
    border: 1px solid grey;
}

#SchoolInfo th {
    text-align: left;
    width: 38%;
}

#SchoolInfo td {
    padding-left: 0.5em;
    color: #555;
    font-weight: 100;
}

@media print {
    #SchoolInfo {
        border-top: none;
    }
}

h2 {
    text-align: center;
    margin-top: 0;
    font-size: 18px;
    padding-bottom: 0.5em;
    border-bottom: 1px solid #8080806e;
}

table {
    width: 100%;
    font-size: 14px;
}

.address {
    color: #555;
    text-align: left;
    /* font-size: 80%; */
}

.specialisation_desc div,
.campus_desc div {
    line-height: 1;
    background: hsl(220, 80%, 98%);
    border-radius: 6px;
    padding: 0.25em 0.5em;
    box-shadow: 2px 2px 3px 3px hsla(0, 0%, 70%, 0.5);
}

.fade-enter-active,
.fade-leave-active {
    transition: opacity 0.5s;
}
.fade-enter,
.fade-leave-to {
    opacity: 0;
}

.maplink {
    text-align: center;
    cursor: pointer;
    color: hsl(240, 100%, 46.7%);
    text-decoration: underline;
    padding: 1em;
    font-size: 14px;
}

.show-zone-link {
    text-align: center;
}

th {
    vertical-align: top;
}
td,
th {
    padding-top: 1em;
}

tr:first-child td,
tr:first-child th,
.specialisation_desc {
    padding-top: 0;
}

table {
    line-height: 1;
}
</style>
